/**
 * @file Main login form.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Alert from '../global/Alert';
import FormGroup from '../global/FormGroup';
import Button from '../global/Button';

class EmailLoginForm extends Component {
  static propTypes = {
    login: PropTypes.func.isRequired,
    error: PropTypes.string,
    loading: PropTypes.bool,
  };

  state = {
    email: '',
    password: '',
  };

  onInputChange = event => {
    const { name, value } = event.target;

    this.setState(() => ({ [name]: value }));
  };

  onLogin = event => {
    event.preventDefault();
    const { email, password } = this.state;
    const { login } = this.props;
    login(email, password);
  };

  render() {
    const { error, loading } = this.props;

    return (
      <form onSubmit={this.onLogin} className="form-login">
        {error && <Alert type="danger">{error}</Alert>}

        <FormGroup
          id="login-email"
          type="email"
          label="Your Email"
          name="email"
          required
          onChange={this.onInputChange}
        />

        <FormGroup
          id="login-password"
          type="password"
          label="Password"
          name="password"
          required
          onChange={this.onInputChange}
        />

        <Button type="submit" btnBlock disabled={loading}>
          Log In
        </Button>
      </form>
    );
  }
}

export default EmailLoginForm;
